import { SEARCH_INPUT_USER_BUYER, SEARCH_OPTION_USER_BUYER } from './constants'

const initialStateSearchInput = {
  searchInputFilter: '',
  enterSearchInputFilter: null,
}

const initialStateSearchOption = {
  searchOptionFilter: '',
  selectedOptions: null,
}

export const searchInput = (state = initialStateSearchInput, action) => {
  switch (action.type) {
    case SEARCH_INPUT_USER_BUYER:
      return {
        ...state,
        searchInputFilter: action.searchValue,
        enterSearchInputFilter: action.enterSearchInputFilter,
      }
    default:
      return state
  }
}
export const searchSelectOption = (
  state = initialStateSearchOption,
  action
) => {
  switch (action.type) {
    case SEARCH_OPTION_USER_BUYER:
      return {
        ...state,
        searchOptionFilter: action.searchOption,
        selectedOptions: action.selectedOptions,
      }
    default:
      return state
  }
}
